(() => {
  const KEY = 'hd-jumpscare-seen-v1';
  const init = () => {
    const el = document.querySelector('[data-hd-jumpscare]');
    if (!el) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const isEditor = Boolean(window.Shopify && window.Shopify.designMode);
    let seen = false;
    try { seen = sessionStorage.getItem(KEY) === '1'; } catch (_) {}
    if (seen && !isEditor) return;
    try { if (!isEditor) sessionStorage.setItem(KEY, '1'); } catch (_) {}
    window.setTimeout(() => {
      el.classList.add('is-active');
      window.setTimeout(() => {
        el.classList.remove('is-active');
        el.setAttribute('hidden', 'hidden');
      }, 2200);
    }, 320);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
